import ExportIcon from '@material-ui/icons/GetApp';
import RotateLeftIcon from "@material-ui/icons/RotateLeft";
import * as React from "react";
import {
	Button,
	sanitizeListRestProps,
	TopToolbar,
	useListContext,
	useRedirect
} from "react-admin";
import { API_URL } from '../config';

const Actions = ({ permissions, ...props }) => {
	const { className, exporter, filters, maxResults, ...rest } = props;
	const redirect = useRedirect();
	const {
		resource,
		displayedFilters,
		filterValues,
		currentSort,
		showFilter,
		perPage,
		page
	} = useListContext();
	return (
		<TopToolbar className={className} {...sanitizeListRestProps(rest)}>
			{filters &&
				React.cloneElement(filters, {
					resource,
					showFilter,
					displayedFilters,
					filterValues,
					context: "button",
				})}
			{permissions && permissions("admin") && (
				<Button
					onClick={() => redirect("/stats-reset")}
					label="resources.stats.actions.reset"
				>
					<RotateLeftIcon />
				</Button>
			)}
			{permissions && permissions("user") && (
				<Button
					onClick={() => {
						const filterQueryAll = {
							...filterValues,
							sort: currentSort?.field,
							direction: currentSort?.order,
							export: "csv",
							group_by: "group_by_user_and_channel",
							limit: perPage,
							page,
							token: localStorage.getItem("token"),
						};

						const filterQuery = Object.keys(filterQueryAll)
							.filter((key) => filterQueryAll[key] !== "")
							.map((key) => `${key}=${filterQueryAll[key]}`)
							.join("&");

						window.open(API_URL + `/${resource}.json?${filterQuery}`);
					}}
					label="ra.action.export"
				>
					<ExportIcon />
				</Button>
			)}
		</TopToolbar>
	);
};

export default Actions;
